import React from 'react';

import CoproID from '../../components/Analyzing/CoproID/CoproID.module';

function CoproIDView() {
  return (
    <CoproID />
  );
}

export default CoproIDView;
